module.exports = __webpack_public_path__ + "static/media/connections_green.a535c30d.svg";